// The file-request questions an agent can answer at request time — the same
// fields the full Listing Request form collects and the request email lists
// (utils/listingRequestEmail.js reads them straight off the file). Pure so the
// merge is unit-testable away from Firestore.

// Whitelist: only these keys ever flow from a request dialog onto the file.
export const FILE_REQUEST_DETAIL_FIELDS = [
  "fileFormat",
  "fileDeadline",
  "listingDate",
  "totalcommissionrate",
  "propertyTrust",
  "sellerDisclosure",
  "preListing",
  "dropOff",
  "photoBook",
  "clientReferal",
  "referredSendGift",
];

// Merge answered details onto a base file-request record. Blank/omitted
// answers leave the base value alone (the team fills those in later), and
// nothing outside the whitelist can sneak onto the deal.
export function applyFileRequestDetails(base = {}, details = {}) {
  const out = { ...base };
  for (const key of FILE_REQUEST_DETAIL_FIELDS) {
    const v = details?.[key];
    const s = (v == null ? "" : String(v)).trim();
    if (s) out[key] = s;
  }
  return out;
}
